import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Layout } from './components/layout';
import { HomePage } from './components/homepage';
import { FindTherapistsPage, ForTherapistsPage, AboutPage, CityPage, TherapistSignupPage, LoginPage, ForgotPasswordPage, ResetPasswordPage, TherapistDashboard, BlogPage, BlogPostPage, TherapistProfilePage, TherapistProfilePageDemo, SuperAdminDashboard, HowItWorksPage, InsurancePage, SpecialtiesPage, ContactPage, PrivacyPolicyPage, TermsOfServicePage } from './components/pages';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="find-therapists" element={<FindTherapistsPage />} />
          <Route path="for-therapists" element={<ForTherapistsPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path="join" element={<TherapistSignupPage />} />
          <Route path="how-it-works" element={<HowItWorksPage />} />
          <Route path="insurance" element={<InsurancePage />} />
          <Route path="specialties" element={<SpecialtiesPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPolicyPage />} />
          <Route path="terms" element={<TermsOfServicePage />} />
        </Route>
        
        {/* Auth and Dashboard routes outside of main layout */}
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password/:resetToken" element={<ResetPasswordPage />} />
        <Route path="therapist/dashboard" element={<TherapistDashboard />} />
        <Route path="admin/dashboard" element={<SuperAdminDashboard />} />
          
        {/* Demo route for viewing the profile page */}
        <Route path="demo/therapist-profile" element={<TherapistProfilePageDemo />} />
        
        {/* Dynamic routes for location-based pages */}
        <Route path="therapists/:state/:city" element={<CityPage />} />
        
        {/* Therapist profile route */}
        <Route path="therapist/:slug" element={<TherapistProfilePage />} />
        
        {/* Catch-all route - redirects unknown paths to homepage */}
        <Route path="*" element={<Navigate to="/" replace />} />
        
        {/* Add more dynamic routes as you build them:
            <Route path="therapists/:state" element={<StatePage />} />
            <Route path="specialties/:specialty" element={<SpecialtyPage />} />
        */}
      </Routes>
    </Router>
  );
}

export default App;
